module.exports = __webpack_public_path__ + "img/82.1dc7e85e.jpg";